/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
// @ts-ignore
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import usaStates from "./states";

import api from "api";
import { Store } from "StoreContext";
import { useLocation } from "react-router-dom";
import Loader from "components/Spinner/Spinner";
import "../../assets/css/mapbox.css";
import BlueDot from "../../assets/img/dot.svg";

import "../../assets/css/table.css";

const AccessTOKEN =
  "pk.eyJ1IjoiemlnemFnZ2VkMDQxMCIsImEiOiJjbTJrbmRqajUwMzQxMmxwejAzNzBqcWJvIn0.uETYRUCiTVjL1bGo-o5JHw";
// const AccessTOKEN = "";
mapboxgl.accessToken = AccessTOKEN;

const WorldMapBox = ({ brandId, orderId, batchId }) => {
  const mapContainerRef = useRef(null);
  const { user } = Store();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [mapStatesData, setMapStatesdata] = useState([]);
  const [mapCountryData, setMapCountrydata] = useState([]);
  const [period, setPeriod] = useState("all");

  const periods = [
    { label: "7 Days", value: "7d" },
    { label: "30 Days", value: "30d" },
    { label: "90 Days", value: "90d" },
    { label: "6 Months", value: "180d" },
    { label: "1 Year", value: "1y" },
    { label: "All Time", value: "all" },
  ];

  useEffect(() => {
    getMapData();
  }, [brandId, orderId, batchId, period]);

  const getMapData = async () => {
    try {
      setLoading(true);
      let queryUrl = `/codes/scan-stats/map`;
      const params = [];
      if (location.pathname.includes("brand")) params.push(`brandId=${user._id}`);
      else if (brandId) params.push(`brandId=${brandId}`);
      if (orderId) params.push(`orderId=${orderId}`);
      if (batchId) params.push(`requestId=${batchId}`);
      if (period) params.push(`period=${period}`);
      if (params.length > 0) queryUrl += `?${params.join("&")}`;
      const res = await api("get", queryUrl);
      const updatedCountryData = res?.countryData.map((item) => {
        if (item.country === "United States") {
          return {
            ...item, // Spread operator to copy the other properties
            country: "United States of America", // Change the country name
          };
        }
        return item; // Return the item unchanged if it's not "United States"
      });
      setMapStatesdata(res?.statesData || []); // Ensure it's an array
      setMapCountrydata(updatedCountryData || []);
      setTimeout(() => {

        setLoading(false);
      }, 1000);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  const getMaxPercentage = () => {
    return Math.max(...mapCountryData.map((item) => item.percentage || 0));
  };

  function getColorByPercentage(percentage, colorIntensity) {
    let color;

    if (percentage <= 1) {
      color = "#e2e9f9"; // Very light blue
    } else if (percentage > 1 && percentage < 5) {
      color = "#dde4f3"; // Light blue
    } else if (percentage >= 5 && percentage < 10) {
      color = "#dfe8fb"; // Light pastel blue
    } else if (percentage >= 10 && percentage < 20) {
      color = "#c5c7fc"; // Light lavender
    } else if (percentage >= 20 && percentage < 30) {
      color = "#bbbdfc"; // Soft lavender
    } else if (percentage >= 30 && percentage < 40) {
      color = "#acaffb"; // Lavender
    } else if (percentage >= 40 && percentage <= 50) {
      color = "#a5a8f8"; // Lighter purple
    } else if (percentage > 50 && percentage < 60) {
      color = "#9295f2"; // Soft purple
    } else if (percentage >= 60 && percentage < 70) {
      color = "#8689e4"; // Pastel purple
    } else if (percentage >= 70 && percentage < 80) {
      color = "#7e81e2"; // Medium purple
    } else if (percentage >= 80 && percentage < 90) {
      color = "#7578d7"; // Darker purple
    } else if (percentage >= 90 && percentage <= 100) {
      color = "#5b71b3"; // Dark blue
    } else {
      color = `#0c2d5a`;
    }

    return color;
  }
  // Get maximum percentage once
  const maxPercentage = getMaxPercentage();
  // Function to determine color and opacity
  const getStateColorAndOpacity = (countryName) => {
    const stateData = mapCountryData.find(
      (item) => item.country === countryName
    );

    const totalCodes = stateData ? stateData.totalCodes : null;
    const percentage = stateData ? stateData.percentage : null;
    const opacity = 0.3 + (percentage / maxPercentage) * (0.8 - 0.3);
    // Calculate opacity from 0.3 to 0.8 based on percentage
    // const opacity = 0.3 + (percentage / maxPercentage) * (0.8 - 0.1);

    // RGB values for base color #b6b8fc (light blue) and dark color #6666cc (darker blue)
    const baseColor = [182, 184, 252]; // Light blue
    const darkColor = [102, 102, 204]; // Darker blue

    // Apply a stronger multiplier for small percentage changes
    const factor = Math.pow(percentage / maxPercentage, 1); // Cubing the percentage change for more noticeable shifts

    // Interpolate between baseColor and darkColor based on the amplified factor
    const colorIntensity = baseColor.map((value, index) => {
      return Math.floor(
        value - factor * (value - darkColor[1]) // Adjust the interpolation to be more sensitive
      );
    });

    // Convert the color to RGB format
    let color = getColorByPercentage(percentage, colorIntensity)

    if (totalCodes) {
      return { color, opacity: 1 }; // Adjust the multiplier for opacity as needed
    } else {
      return { color: "#f2f2f2", opacity: 1 }; // Default opacity for states without codes
    }
  };

  useEffect(() => {
    const fetchGeoJson = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/PublicaMundi/MappingAPI/master/data/geojson/countries.geojson"
        );
        const data = await response.json();

        // Create a mapping of state names to abbreviations
        const stateAbbrMap = {};
        usaStates.forEach((state) => {
          stateAbbrMap[state.name] = state.abbreviation;
        });

        // Set colors and opacity for each state based on the state data
        data.features.forEach((feature) => {
          const countryName = feature.properties.name;
          const { color, opacity } = getStateColorAndOpacity(countryName);

          // Assign the determined color and opacity
          feature.properties.color = color;
          feature.properties.opacity = opacity;
        });

        if (mapContainerRef.current) {
          const mapInstance = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: "mapbox://styles/mapbox/light-v10",

            attributionControl: false,
            center: [-93.0977, 41.878],
            zoom: window.innerWidth < 768 ? 1 : 3,
            maxBounds: [
              [-180, -85], // Southwest corner of the map
              [180, 85], // Northeast corner of the map
            ],
          });

          mapInstance.on("load", () => {
            // Remove default labels, borders, and other layers for a clean look
            mapInstance.getStyle().layers.forEach((layer) => {
              if (
                layer.type === "symbol" || // City and country labels
                layer.type === "line" || // Country and state borders
                layer.id.includes("road") || // Roads
                layer.id.includes("admin") || // Administrative borders
                layer.id.includes("poi") || // Points of interest
                layer.id.includes("landuse") || // Land use areas like parks
                layer.id.includes("building") || // Buildings
                layer.id.includes("waterway") || // Water features like rivers
                layer.id.includes("contour") || // Terrain contours
                layer.id.includes("terrain") || // Terrain details
                layer.id.includes("hillshade") // Shaded relief for terrain
              ) {
                mapInstance.setLayoutProperty(layer.id, "visibility", "none");
              }
            });
            // Add GeoJSON source
            mapInstance.addSource("states", {
              type: "geojson",
              data: data,
            });

            // Add a layer to style the states
            mapInstance.addLayer({
              id: "states-layer",
              type: "fill",
              source: "states",
              paint: {
                "fill-color": ["get", "color"], // Use the color defined in GeoJSON properties
                "fill-opacity": ["get", "opacity"], // Use the opacity defined in GeoJSON properties
              },
            });
            // Add a layer for the country borders
            mapInstance.addLayer({
              id: "state-borders",
              type: "line",
              source: "states",
              paint: {
                "line-color": "#FFFFFF", // White border color
                "line-width": 2, // Width of the border
              },
            });

            // Change ocean color
            mapInstance.setPaintProperty("water", "fill-color", "white");

            // const layers = mapInstance.getStyle().layers;
            // layers.forEach((layer) => {
            //     if (layer.id.includes("water") || layer.id.includes("ocean") || layer.id.includes("waterway")) {
            //         mapInstance.removeLayer(layer.id);
            //         mapInstance.setPaintProperty("water", "fill-color", "white");
            //     }
            // });
            // const layers = mapInstance.getStyle().layers;
            // layers.forEach((layer) => {
            //     if (
            //         layer.id.includes("water") ||
            //         layer.id.includes("ocean") ||
            //         layer.id.includes("waterway")
            //     ) {
            //         // Change the fill color of water areas to white
            //         if (layer.type === "fill") {
            //             mapInstance.setPaintProperty(layer.id, "fill-color", "#ffffff");
            //         }

            //         // Change the text color for water labels to white
            //         if (layer.type === "symbol" && layer.layout["text-field"]) {
            //             mapInstance.setPaintProperty(layer.id, "text-color", "#ffffff");
            //         }
            //     }
            // });

            // Add the popup for hovering over states
            const popup = new mapboxgl.Popup({
              closeButton: false,
              closeOnClick: false,
            });

            // Event handler to display popup on hover
            mapInstance.on("mousemove", "states-layer", (e) => {
              const stateName = e.features[0]?.properties?.name;

              // Check if stateAbbreviation is in mapStatesData
              const stateData = mapCountryData.find(
                (item) => item.country === stateName
              );
              const totalCodes = stateData ? stateData.totalCodes : "";
              const percentAge = stateData ? stateData.percentage : "";

              if (stateName) {
                // Set the HTML for the popup
                const popupContent = stateData
                  ? `<strong>${stateName} - Valid Code: ${percentAge}%</strong>`
                  : `<strong>${stateName}</strong>`;

                popup
                  .setLngLat(e.lngLat)
                  .setHTML(popupContent)
                  .addTo(mapInstance);
              }
            });

            // Event handler to remove popup when mouse leaves
            mapInstance.on("mouseleave", "states-layer", () => {
              popup.remove();
            });
          });

          // Cleanup function
          return () => {
            mapInstance.remove();
          };
        }
      } catch (error) {
        console.error("Error fetching state boundaries:", error);
      }
    };

    void fetchGeoJson();
  }, [mapContainerRef, mapCountryData]);

  const combineStateData = (mapStatesData) => {
    return (
      mapStatesData
        .map((item) => {
          // Find matching state by abbreviation
          const matchedState = usaStates.find(
            (state) => state.abbreviation === item.state
          );

          // Return a new object combining parsed totalCodes as a number, state, and name
          return {
            totalCodes: item.totalCodes,
            state: item.state,
            name: matchedState ? matchedState.name : null,
          };
        })
        // Filter out states with 0 scans and sort by totalCodes descending
        .filter((item) => item.totalCodes > 0)
        .sort((a, b) => b.totalCodes - a.totalCodes)
    );
  };

  return (
    <div className="mapbox-main">
      <div className="inner-country-data">
        <div className="d-flex align-items-center" style={{ padding: "8px 0", gap: "8px", flexWrap: "wrap" }}>
          {periods.map((p) => (
            <button
              key={p.value}
              onClick={() => setPeriod(p.value)}
              style={{
                fontFamily: 'Outfit',
                fontWeight: 600,
                fontSize: '14px',
                backgroundColor: period === p.value ? '#362FD8' : '#F0F0F0',
                color: period === p.value ? '#fff' : '#333',
                border: 'none',
                borderRadius: '6px',
                padding: '6px 16px',
                cursor: 'pointer',
              }}
            >
              {p.label}
            </button>
          ))}
        </div>

        <div style={{ gap: '20px' }} className="d-flex flex-sm-row flex-column justify-content-between">
          {/* Top Countries — primary focus on World view */}
          <div className="custom-table" style={{ flex: 1 }}>
            <div className="table-header"><h2 className="vs-section-title">Top Countries</h2></div>
            <div className="table-body">
              {mapCountryData.length > 0 ? (
                mapCountryData
                  .filter((country) => country.totalCodes > 0)
                  .sort((a, b) => b.totalCodes - a.totalCodes)
                  .map((country, index) => (
                  <div className="table-row" key={index}>
                    <div className="dot-row">
                      <img src={BlueDot} alt="dot" />
                      {String(country.name || country.country || '')}
                    </div>
                    <div className="td-2">{country.totalCodes?.toLocaleString() || "N/A"}</div>
                  </div>
                ))
              ) : (
                <div className="table-row">
                  <span style={{ color: '#888' }}>No data available for countries.</span>
                </div>
              )}
            </div>
          </div>

          {/* Top Cities — all cities globally from all states */}
          <div className="custom-table" style={{ flex: 1 }}>
            <div className="table-header"><h2 className="vs-section-title">Top Cities</h2></div>
            <div className="table-body">
              {mapStatesData.length > 0 ? (
                (() => {
                  const allCities = [];
                  for (const state of mapStatesData) {
                    for (const city of (state.cities || [])) {
                      if (city.totalCodes > 0) {
                        allCities.push({ city: city.city, state: state.state, totalCodes: city.totalCodes });
                      }
                    }
                  }
                  allCities.sort((a, b) => b.totalCodes - a.totalCodes);
                  return allCities.slice(0, 15).map((item, index) => (
                    <div className="table-row" key={index}>
                      <div className="dot-row">
                        <img src={BlueDot} alt="dot" />
                        {item.city}{item.state ? `, ${item.state}` : ''}
                      </div>
                      <div className="td-2">{item.totalCodes?.toLocaleString()}</div>
                    </div>
                  ));
                })()
              ) : (
                <div className="table-row">
                  <span style={{ color: '#888' }}>No city data available.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="mapbox-map-container"
      // style={{
      //   width: "98%",
      //   margin: "2% auto",
      //   height: "500px",
      //   position: "relative",
      //   borderRadius: "10px",
      // }}
      >
        {loading ? (
          <div
            className="mapbox-map-loader"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
              borderRadius: "10px",
              zIndex: 2,
            }}
          >
            <Loader />
          </div>
        ) : null}
        <div
          ref={mapContainerRef}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            visibility: loading ? "hidden" : "visible",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
      </div>
    </div>
  );
};

export default WorldMapBox;
